import { SelectFields } from '@repo/toolkit/types'

import { Enrollment } from '../../lib/types/models/enrollment/enrollment'
import { FieldsSelector } from '../../lib/types/utils'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEnrollment<T extends FieldsSelector<Enrollment>>(id: number, fields: T) {
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.enrollments.get.url, { id }), { fields }))
    .get<SelectFields<Enrollment, T>>()
}
